// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import convert from 'heic-convert/browser';

import { MIME_TYPES } from '@savgroup-front-common/constants';

export class ImageConverter {
  static heiToJpg = async (file: File) => {
    const isHeif = file.name.toLowerCase().includes('.heif');
    const isHeic = file.name.toLowerCase().includes('.heic');

    if (isHeif || isHeic) {
      const output = await convert({
        buffer: new Uint8Array(await file.arrayBuffer()),
        format: 'JPEG',
      });

      return new File(
        [output],
        file.name
          .replace(isHeif ? '.heif' : '.heic', '.jpg')
          .replace(isHeif ? '.HEIF' : '.HEIC', '.jpg'),
        {
          type: MIME_TYPES.JPEG,
        },
      );
    }

    return file;
  };
}
